/**
 * Track Form Submit Success Event
 */

import { logDebug, pushToAdobeDataLayer } from './utils';

export interface FormSubmitSuccessParams {
    /** Form type (e.g., 'contact') */
    type: string;
    /** Form name (e.g., 'General Contact Request') */
    name: string;
    /** Form ID (e.g., 'DUDAA29232') */
    id: string;
    /** Form destination (e.g., 'ACS') */
    destination: string;
    /** Form topic (e.g., 'contract') */
    topic: string;
}

/**
 * Track a form submit success event
 */
export const trackFormSubmitSuccess = async ({
    type,
    name,
    id,
    destination,
    topic,
}: FormSubmitSuccessParams): Promise<void> => {
    logDebug('Tracking form submit success...');
    const payload = {
        event: 'formSubmitSuccess',
        _volvo: {
            universal: {
                web: {
                    form: {
                        type,
                        name,
                        id,
                        destination,
                        topic,
                        formSubmitSuccess: {
                            value: 1,
                        },
                    },
                },
            },
        },
        web: {
            webInteraction: {
                type: 'other',
            },
        },
    };
    await pushToAdobeDataLayer(payload);
};
